import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    productInfos?: Omit<ProductInfo, "productDetailPath">[];
    modalIsOpen: boolean;
}

type HandlerType = Handler<Parameter>;

export const DispatchCompleteSetInventoryResultsModalIsOpen: HandlerType = props => {
    props.dispatch({
        type: "Custom/InventoryResultsModal/CompleteSetIsOpen",
        isOpen: props.parameter.modalIsOpen,
        productInfos: props.parameter.productInfos,
    } as any);
};

export const chain = [DispatchCompleteSetInventoryResultsModalIsOpen];

const setInventoryResultsModalIsOpen = createHandlerChainRunner(chain, "SetInventoryResultsModalIsOpen");
export default setInventoryResultsModalIsOpen;
